// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:34:49

export default {
  "id": "sprunki-challenge",
  "slug": "sprunki-challenge",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/b21ecd2488a5406ab3eee6843fcc1690-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/b21ecd2488a5406ab3eee6843fcc1690/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Sprunki Challenge",
      "description": "Sprunki Challenge game adds a challenge mode to the famous Sprunki game and activates the game's battle mode. While the 1 Player mode of the game includes the classic mode, in the 2 Player mode you both make music using Sprunki characters and try to reach 2000 by generating scores. You can play the game with your friend in both dark mode and normal mode. If you want, you can also activate different backgrounds.",
      "instructions": "Use the \"LEFT-MOUSE\" button to interact with objects. You can use touch controls on mobile devices.",
      "genres": [
        "Casual",
        "Simulation"
      ],
      "tags": [
        "1player",
        "2players",
        "music",
        "musical"
      ]
    },
    "zh-CN": {
      "title": "斯普伦基挑战",
      "description": "Sprunki Challenge 游戏为著名的 Sprunki 游戏增添了挑战模式并激活了战斗模式。在单人模式中，游戏包含经典模式；而在双人模式中，你和你的朋友可以使用 Sprunki 角色创作音乐，并通过生成分数争取达到 2000 分。你可以与朋友在暗黑模式和正常模式中游玩游戏。如果你愿意，还可以激活不同的背景。",
      "instructions": "使用“左鼠标键”与物体互动。在移动设备上可以使用触摸控制。",
      "genres": [
        "休闲",
        "模拟"
      ],
      "tags": [
        "1人玩家",
        "2人玩家",
        "音乐",
        "音乐剧"
      ]
    },
    "zh-TW": {
      "title": "湯姆挑戰",
      "description": "Sprunki挑戰遊戲為著名的Sprunki遊戲增添了挑戰模式並啟動遊戲的戰鬥模式。當前遊戲的1人模式包含經典模式，而在2人模式中，你們將使用Sprunki角色製作音樂並嘗試通過生成分數達到2000分。你可以與朋友在暗黑模式和正常模式下遊玩遊戲。如果你願意，你也可以啟用不同的背景。",
      "instructions": "使用“左鍵”與物件互動。在行動裝置上，您可以使用觸控功能。",
      "genres": [
        "隨意",
        "模擬"
      ],
      "tags": [
        "1人遊玩",
        "2人遊玩",
        "音樂",
        "音樂會"
      ]
    },
    "zh-HK": {
      "title": "斯普林基挑戰",
      "description": "Sprunki挑戰遊戲為著名的Sprunki遊戲增添挑戰模式並啟動遊戲的戰鬥模式。遊戲的1人模式包括經典模式，而在2人模式中，你們兩人使用Sprunki角色製作音樂，並試圖通過生成分數達到2000分。你可以與朋友在暗黑模式及普通模式下遊戲。如果你願意，你也可以啟動不同的背景。",
      "instructions": "使用“左鍵”按鈕與對象互動。在行動裝置上可以使用觸控操作。",
      "genres": [
        "休闲",
        "模擬"
      ],
      "tags": [
        "1人玩",
        "2人玩",
        "音樂",
        "音樂會"
      ]
    },
    "ja": {
      "title": "スプリンクチャレンジ",
      "description": "Sprunki Challengeゲームは、有名なSprunkiゲームに挑戦モードを追加し、ゲームのバトルモードを活性化します。ゲームの1プレイヤーモードにはクラシックモードが含まれており、2プレイヤーモードでは、Sprunkiキャラクターを使って音楽を作成し、得点を上げて2000に達することを目指します。友達とダークモードおよびノーマルモードでゲームを楽しむことができます。必要に応じて、異なる背景をアクティベートすることもできます。",
      "instructions": "オブジェクトとの対話には「左マウスボタン」を使用してください。モバイルデバイスではタッチコントロールを使用できます。",
      "genres": [
        "カジュアル",
        "シミュレーション"
      ],
      "tags": [
        "1プレイヤー",
        "2プレイヤー",
        "音楽",
        "音楽的"
      ]
    },
    "ko": {
      "title": "스프런키 챌린지",
      "description": "스프끄니 챌린지 게임은 유명한 스프끄니 게임에 도전 모드를 추가하고 전투 모드를 활성화합니다. 1플레이어 모드는 클래식 모드를 포함하되, 2플레이어 모드에서는 스프끄니 캐릭터를 사용하여 음악을 만들고 점수를 만들어 2000점에 도달하려고 합니다. 양자 모드에서는 어둡고 일반 모드에서도 친구와 게임을 할 수 있으며, 원하시면 다양한 배경을 활성화할 수도 있습니다.",
      "instructions": "\"왼쪽 마우스 버튼\"을 사용하여 객체와 상호작용하세요. 모바일 장치에서는 터치 제어를 사용할 수 있습니다.",
      "genres": [
        "캐주얼",
        "시뮬레이션"
      ],
      "tags": [
        "1플레이어",
        "2플레이어",
        "음악",
        "음악극"
      ]
    },
    "fr": {
      "title": "Défi Sprunki",
      "description": "Le jeu Sprunki Challenge ajoute un mode défi au célèbre jeu Sprunki et active le mode bataille du jeu. Alors que le mode 1 Joueur inclut le mode classique, dans le mode 2 Joueur, vous deux composez de la musique en utilisant les personnages Sprunki et essayez d'atteindre 2000 points en générant des scores. Vous pouvez jouer au jeu avec votre ami en mode sombre et en mode normal. Si vous le souhaitez, vous pouvez également activer différents arrière-plans.",
      "instructions": "Utilisez le \"bouton GAUCHE DE LA SOURIS\" pour interagir avec les objets. Vous pouvez utiliser les commandes tactiles sur les appareils mobiles.",
      "genres": [
        "Occasionnel",
        "Simulation"
      ],
      "tags": [
        "1 joueur",
        "2 joueurs",
        "musique",
        "musical"
      ]
    }
  }
};
